/** @format */

import { Axios } from '../utils/gatsby/createAxiosInstance';

export type PromoBannerRequest = {
  buildingId: string | null;
  bedCode: string | null;
  flatId: string | null;
  cityId: string | null;
};

export type PromoBannerResponse = {
  id: string;
  activeFrom: string;
  activeTo: string | null;
  buildingId: string | null;
  bedCode: string | null;
  flatId: string | null;
  cityId: string | null;
  translations: {
    it: string;
    en: string;
    fr: string;
    es: string;
  };
};

export const apiPromoBanner = async (body: PromoBannerRequest): Promise<PromoBannerResponse | undefined> => {
  try {
    const URL = '/WebsiteBanners/Banners';
    const response = await Axios.post(URL, body);
    return response.data;
  } catch (error) {
    console.error('apiPromoBanner error', error, body);
    return undefined;
  }
};
